import React, { useContext, useState } from "react";
import { Table, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@material-ui/core";
import CustomPagination from "components/common/Table/CustomPagination";
import { BreakpointContext } from "components/common";
import electricityIcon from "assets/transaction_category/electricity.svg";
import gasIcon from "assets/transaction_category/gas.svg";
import gymIcon from "assets/transaction_category/gym.svg";
import internetIcon from "assets/transaction_category/internet.svg";
import otherIcon from "assets/transaction_category/other.svg";
import phoneIcon from "assets/transaction_category/phone.svg";
import houseIcon from "assets/transaction_category/rent.svg";
import streamingIcon from "assets/transaction_category/streaming.svg";
import utilitiesIcon from "assets/transaction_category/utilities.svg";

const CATEGORY_ICON_MAP = {
  "Mobile Phone": phoneIcon,
  "Utilities": utilitiesIcon,
  "Internet": internetIcon,
  "Television / Video Streaming": streamingIcon,
  "Gym": gymIcon,
  "Electricity": electricityIcon,
  "Gas": gasIcon,
  "Rent": houseIcon,
  "Other": otherIcon,
};

const TRANSACTION_TABLE_PAGE_SIZE = 9;

const useColumns = () => {
  const { isBelow } = useContext(BreakpointContext);
  const isBelowSm = isBelow("sm");
  const isBelowMdl = isBelow("mdl");
  const isBelowLg = isBelow("lg");

  return [
    ...(isBelowLg
      ? []
      : [
        {
          Header: "DATE",
          accessor: (data) => (
            <p className="text-base font-normal truncate">
              {data.posted_date
                ? new Date(data.posted_date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
                : ""}
            </p>
          ),
        },
      ]),
    {
      Header: "DESCRIPTON",
      accessor: (data) => (
        <div className="flex flex-col">
          <p className="text-base font-medium">{data.description}</p>
          {isBelowLg && (
            <p className="text-xs font-normal">
              {data.posted_date
                ? new Date(data.posted_date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
                : ""}
            </p>
          )}
        </div>
      ),
    },
    ...(isBelowSm || (!isBelowMdl && isBelowLg)
      ? []
      : [
        {
          Header: "CATEGORY",
          accessor: (data) => (
            <Tooltip title={data.category}>
              <div className="flex items-center justify-center">
                <img
                  src={
                    data.category in CATEGORY_ICON_MAP
                      ? CATEGORY_ICON_MAP[data.category]
                      : CATEGORY_ICON_MAP.Other
                  }
                  alt={data.category}
                  style={{ width: 18, height: 18 }}
                />
              </div>
            </Tooltip>
          ),
        },
      ]),
    {
      Header: "AMOUNT",
      accessor: (data) => (
        <p className="text-base font-medium">${data.amount}</p>
      ),
    },
  ];
};

const TransactionTable = ({ transactions, setShowSelfAdd }) => {
  const [page, setPage] = useState(0);
  const columns = useColumns();

  const slicedTransactions = transactions?.slice(
    page * TRANSACTION_TABLE_PAGE_SIZE,
    (page + 1) * TRANSACTION_TABLE_PAGE_SIZE,
  ) || [];

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.Header}>{column.Header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {slicedTransactions.map((row) => (
              <TableRow key={row.name}>
                {
                  columns.map((column) =>
                    <TableCell key={`${column.Header} ${row.id}`}>
                      {column.accessor(row)}
                    </TableCell>,
                  )
                }
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div
        className="flex flex-col items-center justify-center sm:flex-row sm:justify-between"
        style={{
          marginTop:
                slicedTransactions.length < TRANSACTION_TABLE_PAGE_SIZE
                  ? (TRANSACTION_TABLE_PAGE_SIZE - slicedTransactions.length) *
                      50 +
                    20
                  : 20,
        }}
      >
        <CustomPagination
          totalCount={transactions.length}
          siblingCount={1}
          currentPage={page}
          pageSize={TRANSACTION_TABLE_PAGE_SIZE}
          onPageChange={setPage}
        />
        <button
          type="button"
          onClick={() => {
            setShowSelfAdd(true);
          }}
          className="text-boost-primary-500 hover:bg-boost-primary-50 active:bg-boost-primary-200 rounded px-4 py-1 focus:outline-none mt-5 sm:mt-0"
        >
              + Don&apos;t see your bills?
        </button>
      </div>
    </>

  );
};

export default TransactionTable;
